import React from 'react';
import { HiInformationCircle } from "react-icons/hi";
import { HiAcademicCap } from "react-icons/hi2";

const TabNavItem = ({id, title, icon, activeTab, setActiveTab}) => {
    const handleClick = () => {
        setActiveTab(id);
    };

    const getIcon = (id) => {
        switch(id) {
            case 4:
                return <img alt="Deutschland" className="flag" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3cpath d='M0 0h5v3H0z'/%3e%3cpath fill='%23D00' d='M0 1h5v2H0z'/%3e%3cpath fill='%23FFCE00' d='M0 2h5v1H0z'/%3e%3c/svg%3e"/>
            case 3:
                return <img alt="United Kingdom (GB)" className="flag" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v30h60V0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M30 15h30v15zv15H0zH0V0zV0h30z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23012169' d='M0 0v30h60V0z'/%3e%3cpath stroke='%23fff' stroke-width='6' d='m0 0 60 30m0-30L0 30'/%3e%3cpath stroke='%23C8102E' stroke-width='4' d='m0 0 60 30m0-30L0 30' clip-path='url(%23b)'/%3e%3cpath stroke='%23fff' stroke-width='10' d='M30 0v30M0 15h60'/%3e%3cpath stroke='%23C8102E' stroke-width='6' d='M30 0v30M0 15h60'/%3e%3c/g%3e%3c/svg%3e"/>;
            case 2:
                return <HiAcademicCap/>
            default:
                return <HiInformationCircle/>;
        }
    }

    return (
        <li key={id} onClick={handleClick} className={activeTab === id ? "active" : ""}>
            {getIcon(icon)}
            { title }
        </li>
    );
};

export default TabNavItem;